import { useContext, useState } from 'react'
import { MdArrowDropDown, MdArrowDropUp, MdLogout, MdMenuBook } from 'react-icons/md'
import {BiUser} from 'react-icons/bi'
import { useNavigate } from 'react-router-dom'
import { signOut, updateProfileImage } from '../Requests/firebaseAuth'
import './UserProfileButton.css'
import UserContext from '../Context/UserContext'
export default function UserProfileButton ({imageUrl, userName}) {
  const [menu, setMenu] = useState(false)
  const navigate = useNavigate()
  const {user} = useContext(UserContext)

  window.onclick = (e) => {
    if(e.target.matches('.dropdown-toggle')){
      setMenu(true)
    }else{
      setMenu(false)
    }
  }

  const downloadManual = () => {
    let link = document.createElement('a')
    link.href = 'https://firebasestorage.googleapis.com/v0/b/channel-talks-web.appspot.com/o/defaultFiles%2Fmanual.pdf?alt=media&token=6c880cf0-de07-40ec-8de6-36acb7ad70e9'
    link.target = '_blank'
    link.download = 'Manual del Expositor - Channel Talks webAPP.pdf'
    link.dispatchEvent(new MouseEvent('click'))
  }

  return(
    <div className='mx-auto inline-block items-center relative'>
      <div className='flex items-center'>

      {imageUrl?
        <img className='image dropdown-toggle' onClick={updateProfileImage} alt="profile" src={imageUrl}/>
      :
        <>
        <svg onClick={updateProfileImage} className='image dropdown-toggle' xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
          <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
          <path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"/>
        </svg>
        </>
      }
      <button className='text-stone-500 flex dropdown-toggle'>
        <span className='text-[#5B2966] font-semibold ml-2 dropdown-toggle'>{userName}</span>
        {menu?<MdArrowDropUp size={25} className='dropdown-toggle'/>:<MdArrowDropDown size={25} className='dropdown-toggle'/>}
      </button>
      </div>
      {menu?
        <div className='dropdown-body' id='dropdown-menu'>
          <button className='dropdown-item' onClick={()=>{navigate(`/${user.role}/profile`)}}><BiUser size={25}/><span className='mx-auto'>Perfil</span></button>
          <button className='dropdown-item' onClick={downloadManual}><MdMenuBook size={25}/><span className='mx-auto'>Descargar manual</span></button>
          <button className='dropdown-item' onClick={signOut}><MdLogout size={25}/><span className='mx-auto'>Cerrar sesión</span></button>
        </div>
      :<></>}
    </div>
  )
}